import * as React from "react";
import { Link } from "react-router";

import { PageBreadcrumbs, PageLayout } from "@/shared/components";
import { Goto } from "@/shared/navigation";

export interface IngestionRulesChromeProps {
  /** The page's own crumb, last in the trail. */
  title: string;
  /** Crumbs between the rules list and this page. */
  crumbs?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Page chrome for a rule's own pages (detail, create, edit). The trail runs
 * through Settings → Ingestion, where the rules list lives.
 */
export function IngestionRulesChrome({
  title,
  crumbs,
  children,
}: IngestionRulesChromeProps) {
  return (
    <PageLayout
      title={`Roboto - ${title}`}
      headerContentLeft={
        <PageBreadcrumbs>
          <Link to={Goto.route.Settings.Organization}>Settings</Link>
          <Link to={Goto.route.Settings.Ingestion.Root}>Ingestion</Link>
          {crumbs}
          <span>{title}</span>
        </PageBreadcrumbs>
      }
    >
      {children}
    </PageLayout>
  );
}
